import _ from "@/boot/lodash";
import UField from "@/components/app-base/UField.vue";

const manualImports = ["UField"];

export default {
  install: (Vue: any) => {
    const requireComponent = require.context(
      "./",
      false,
      /[A-Z]\w+\.(vue)$/,
      "lazy"
    );
    requireComponent.keys().forEach(fileName => {
      fileName = fileName.substring(2);
      // Get the PascalCase version of the component name
      const componentName = _.upperFirst(fileName.replace(/\.\w+$/, ""));
      if (manualImports.includes(componentName)) return;
      Vue.component(componentName, () =>
        import(`@/components/app-base/${fileName}`)
      );
    });
    // Register manual imports
    Vue.component("u-field", UField);
  }
};
